/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { SampleTypeDto } from './sampleTypeDto';
import type { ChildSubCategoryDto } from './childSubCategoryDto';
import type { ChildFamilyDto } from './childFamilyDto';

export interface DiagnosticProcedureDto {
  /** Diagnostic procedure ID */
  id: string;
  /** Category of test */
  categoryOfTest?: string;
  /** Extra test information */
  extraTestInformation?: string;
  /** Number of positive tests */
  numberOfPositiveTests?: number;
  /** Number of negative tests */
  numberOfNegativeTests?: number;
  /** Total number of tests */
  numberOfTests?: number;
  /** Sample type */
  sampleType?: SampleTypeDto;
  /** Sub category */
  subCategory?: ChildSubCategoryDto;
  /** Family */
  family?: ChildFamilyDto;
}
